type criticalStepNames = 'location_date_time_page_load' | 'complete';
import makeRequestHeaders from '@src/utils/make-request-headers';

type DataLayerStepData = {
	lead_segment?: number;
	lead_tier?: string;
	step_name?: string;
};

/**
 * @method DataLayerIntegrityCheck
 *
 * This parses specific fields out of the datalayer mostly for the purpose
 * of ensuring lead segmentation is not sending the default value of '21' at
 * a rate that indicates a bug in the FE code.
 */
const DataLayerIntegrityCheck = async (stepName: criticalStepNames, sessionId = 'N/A', enableHydraCalls = false) => {
	try {
		const currentDataLayer = dataLayer as DataLayerStepData[];
		const matchingStepData = currentDataLayer.filter((item) => item?.step_name === stepName);

		if (matchingStepData && matchingStepData.length > 0) {
			const latestMatch: DataLayerStepData = matchingStepData[matchingStepData.length - 1];
			const { lead_segment, lead_tier } = latestMatch;

			const data = {
				stepName,
				leadTier: lead_tier,
				leadSegment: lead_segment,
			};

			fetch(process.env.APP_PATH + '/api/clear-choice/datalayer-integrity/', {
				headers: makeRequestHeaders({ sessionId, enableHydraCalls }),
				method: 'POST',
				body: JSON.stringify(data),
			});
		} else {
			throw new Error(`no DL match for step name "${stepName}" in datalayer integrity check`);
		}
	} catch (e) {
		console.error('error @: datalayer-integrity-check:');
		console.error(e);
	}
};

export default DataLayerIntegrityCheck;
